// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChartsController from "./charts_controller"
application.register("charts", ChartsController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ContentBlockController from "./content_block_controller"
application.register("content-block", ContentBlockController)

import CookieNoticeController from "./cookie_notice_controller"
application.register("cookie-notice", CookieNoticeController)

import CustomFileController from "./custom_file_controller"
application.register("custom-file", CustomFileController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import DisableOnCheckController from "./disable_on_check_controller"
application.register("disable-on-check", DisableOnCheckController)

import DropdownAjaxController from "./dropdown_ajax_controller"
application.register("dropdown-ajax", DropdownAjaxController)

import EmbedIframeController from "./embed_iframe_controller"
application.register("embed-iframe", EmbedIframeController)

import EmbeddedContactSelectController from "./embedded_contact_select_controller"
application.register("embedded-contact-select", EmbeddedContactSelectController)

import FillInCompanyController from "./fill_in_company_controller"
application.register("fill-in-company", FillInCompanyController)

import FixedFooterController from "./fixed_footer_controller"
application.register("fixed-footer", FixedFooterController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import FormController from "./form_controller"
application.register("form", FormController)

import GroupContactController from "./group_contact_controller"
application.register("group-contact", GroupContactController)

import GroupDurationController from "./group_duration_controller"
application.register("group-duration", GroupDurationController)

import GroupFormController from "./group_form_controller"
application.register("group-form", GroupFormController)

import GroupPackageController from "./group_package_controller"
application.register("group-package", GroupPackageController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InplaceEditingController from "./inplace_editing_controller"
application.register("inplace-editing", InplaceEditingController)

import InvoicesController from "./invoices_controller"
application.register("invoices", InvoicesController)

import LazyModalController from "./lazy_modal_controller"
application.register("lazy-modal", LazyModalController)

import MaxMembersCountToPackageController from "./max_members_count_to_package_controller"
application.register("max-members-count-to-package", MaxMembersCountToPackageController)

import MaxMembersToGroupPackageController from "./max_members_to_group_package_controller"
application.register("max-members-to-group-package", MaxMembersToGroupPackageController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import NavsearchController from "./navsearch_controller"
application.register("navsearch", NavsearchController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OnboardingCompanyController from "./onboarding_company_controller"
application.register("onboarding-company", OnboardingCompanyController)

import OrderController from "./order_controller"
application.register("order", OrderController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PdfObjectController from "./pdf_object_controller"
application.register("pdf-object", PdfObjectController)

import PiechartController from "./piechart_controller"
application.register("piechart", PiechartController)

import PlacesController from "./places_controller"
application.register("places", PlacesController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import RecommenderClickTrackingController from "./recommender_click_tracking_controller"
application.register("recommender-click-tracking", RecommenderClickTrackingController)

import RecommenderViewTrackingController from "./recommender_view_tracking_controller"
application.register("recommender-view-tracking", RecommenderViewTrackingController)

import RegionController from "./region_controller"
application.register("region", RegionController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import RemoteSearchController from "./remote_search_controller"
application.register("remote-search", RemoteSearchController)

import RemoteSearchMaterialController from "./remote_search_material_controller"
application.register("remote-search-material", RemoteSearchMaterialController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SubmitButtonLabelController from "./submit_button_label_controller"
application.register("submit-button-label", SubmitButtonLabelController)

import SubmitOnChangeController from "./submit_on_change_controller"
application.register("submit-on-change", SubmitOnChangeController)

import SubnavController from "./subnav_controller"
application.register("subnav", SubnavController)

import SubscriptionsController from "./subscriptions_controller"
application.register("subscriptions", SubscriptionsController)

import TeaserController from "./teaser_controller"
application.register("teaser", TeaserController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleOnCheckController from "./toggle_on_check_controller"
application.register("toggle-on-check", ToggleOnCheckController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UpdateLicensePriceController from "./update_license_price_controller"
application.register("update-license-price", UpdateLicensePriceController)

import VideoController from "./video_controller"
application.register("video", VideoController)

import VimeoController from "./vimeo_controller"
application.register("vimeo", VimeoController)

import WordCountController from "./word_count_controller"
application.register("word-count", WordCountController)
